import { gql } from '@apollo/client/core';

export const getUserProfileContactInfo = gql`
  query getUserProfileContactInfo($where: UserProfileWhereUniqueInput) {
    social {
      userProfile(where: $where) {
        code
        adviseMessage {
          description
        }
        userProfileData {
          onboardingProperties {
            contactsInfo
          }
        }
      }
    }
  }
`;
